import { apiSlice } from 'api/apiSlice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<any, any>({
      query: (slug) => {
        return {
          url: '/placement-role',
          params: slug,
        };
      },
      transformResponse: (res: any) => res.data,
      providesTags: ['Roles'],
    }),

    addRole: builder.mutation({
      query(data: any) {
        const { ...body } = data;
        return {
          url: `/placement-role`,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: ['Roles'],
    }),
    updateRole: builder.mutation({
      query(data: any) {
        const { ...body } = data;
        return {
          url: `/placement-role`,
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: ['Roles'],
    }),
  }),
});

export const { useGetRolesQuery, useAddRoleMutation, useUpdateRoleMutation } =
  extendedApiSlice;
